import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {
  selectActualLicenses,
  selectActualTimezone,
  selectActualWorkdays,
  selectEulaType,
  SelectFirstLoginCountry,
  selectIsFirstLogin,
} from 'containers/App/selectors'

import FirstLoginModal from 'components/elements/FirstLoginForm/FirstLoginModal'

import actions from './actions'
import { selectError, selectIsLoading, selectIsSuccussful, selectMessage } from './selectors'

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)
const mapStateToProps = (state) => ({
  licenses: selectActualLicenses(state),
  loader: selectIsLoading(state),
  message: selectMessage(state),
  error: selectError(state),
  success: selectIsSuccussful(state),
  isFirstLogin: selectIsFirstLogin(state),
  eulaType: selectEulaType(state),
  defaultWorkDays: selectActualWorkdays(state),
  defaultTimezone: selectActualTimezone(state),
  defaultCountry: SelectFirstLoginCountry(state),
})

const render = connect(mapStateToProps, mapDispatchToProps)(FirstLoginModal)

export default render
